import {useSelector} from 'react-redux';
import {selectFabricArt} from '~/CreateFabricGreetingCard/reducers/fabricDesign/selectors';
import {Card} from '~/common/canvas/Card/Card';
import {Sections} from '~/common/FabricInvitation/EventCreateDesign/constants';
import {Envelope as EnvelopeImage} from '~/common/fabric/Card/components/Envelope/Envelope';
import {useLiners} from '~/common/fabric/CreateDesign/components/Envelope/actions/useLiner';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {largishAndUp} from '~libSass/base/_exports.sass';

export const Envelope = () => {
  const {selectedLiner} = useLiners();
  const fabricArt = useSelector(selectFabricArt);
  const {matches: isDesktop} = useMatchQuery(`(min-width: ${largishAndUp})`);

  return (
    <div className="envelope">
      <div className="envelope__images">
        <Card
          className="envelope__images__card"
          fabricArt={fabricArt}
          redirectTo={isDesktop ? Sections.CARD_DESIGN : null}
        />
        <EnvelopeImage
          type="blank"
          className="envelope__images__envelope"
          selectedLiner={selectedLiner?.image}
        />
      </div>
    </div>
  );
};
